import { Injector, NgModule } from '@angular/core';
import { createCustomElement } from '@angular/elements';
import { CONSTANTS } from '../global';
import { VerifyZipcodeModalComponent } from '../components/verify-zipcode-modal/verify-zipcode-modal.component';
import { DtAnZipcodeSharedModule } from './dt-an-zipcode-shared.module';
import { ZipSlideoutComponent } from '../components/zip-slideout/zip-slideout.component';


@NgModule({
  declarations: [
    VerifyZipcodeModalComponent,
    ZipSlideoutComponent
  ],
  imports: [
    DtAnZipcodeSharedModule
  ],
  exports: [
    VerifyZipcodeModalComponent,
    ZipSlideoutComponent
  ]
})
export class DtAnVerifyZipcodeModalModule {
  constructor(private injector: Injector) {
    if (!customElements.get(CONSTANTS.VERIFY_ELEMENT_NAME)) {
      const verifyModalElement = createCustomElement(ZipSlideoutComponent, { injector });
      customElements.define(CONSTANTS.VERIFY_ELEMENT_NAME, verifyModalElement);
      document.body.appendChild(document.createElement(CONSTANTS.VERIFY_ELEMENT_NAME));
    }
  }
}
